// Shared formatting and keys for the game's screens: London times as players see them, and the one-use keys
// that make a paid action happen once however many times it is sent.

const LONDON = 'Europe/London';

// "Sat 9:00 am": a day and time this week (bills due, invites until, fares locked until)
export const londonWhen = (iso: string) =>
  new Date(iso).toLocaleString('en-GB', {
    weekday: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: LONDON,
  });

// "Sat 24 Oct": a day further off (rent due)
export const londonDay = (iso: string | Date) =>
  new Date(iso).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: LONDON });

// "14:31": the time on London's clock
export const londonClock = (at: string | Date) =>
  new Date(at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: LONDON });

// "now", "5m", "3h", "2d": how long ago, short (Gist, as Lagos Life shows it)
export const ago = (iso: string, now = Date.now()) => {
  const minutes = Math.max(0, Math.round((now - new Date(iso).getTime()) / 60_000));
  return minutes < 1
    ? 'now'
    : minutes < 60
      ? `${minutes}m`
      : minutes < 1440
        ? `${Math.round(minutes / 60)}h`
        : `${Math.round(minutes / 1440)}d`;
};

// a fresh key for one action ("railco-…"); the server does it once per key
export const actionKey = (kind: string) => `${kind}-${crypto.randomUUID()}`;

// "£12.50" typed in, as pence (0 when it is not an amount)
export const typedPence = (text: string) => {
  const value = Math.round(Number(text.replace(/[£,\s]/g, '')) * 100);
  return Number.isFinite(value) && value > 0 ? value : 0;
};
